export default __webpack_public_path__ + "static/media/Group 13000.f4036174.svg";